import { reportError } from '../errors/reportError'

const STORAGE_PROBE_KEY = '__stoutcamp_storage_probe__'

let storageAvailable = true
let hasProbedStorage = false
let hasReportedStorageFailure = false

export function isStorageAvailable(): boolean {
  return storageAvailable
}

export function probeStorage(): boolean {
  if (hasProbedStorage) {
    return storageAvailable
  }

  hasProbedStorage = true

  try {
    window.localStorage.setItem(STORAGE_PROBE_KEY, '1')
    window.localStorage.removeItem(STORAGE_PROBE_KEY)
    storageAvailable = true
  } catch (err) {
    storageAvailable = false

    if (!hasReportedStorageFailure) {
      hasReportedStorageFailure = true
      reportError(err, 'probeStorage.init', {
        level: 'warning',
        extra: {
          userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : 'unknown',
        },
      })
    }
  }

  return storageAvailable
}
